import { computed } from '@vue/composition-api';
import { MaybeComputedElementRef, useElementBounding } from '@vueuse/core';

/**
 * mini版标题的样式
 * @param params 标题元素和tab元素
 */
export function useMiniHeader(params: {
  headerEl: MaybeComputedElementRef;
  tabEl: MaybeComputedElementRef;
}) {
  const { headerEl, tabEl } = params;
  const { height: headerHeight } = useElementBounding(headerEl);
  const { top: tabTop, height: tabHeight } = useElementBounding(tabEl);
  const opacity = computed(() => {
    const headerBeginShowTop = headerHeight.value * 3; // 标题开始展示的top值
    const headerCompeleteShowTop = headerHeight.value; // 标题完全展示的top值
    const allProgress = headerBeginShowTop - headerCompeleteShowTop; // 开始展示到结束展示的整体长度
    const passProgress = tabTop.value - headerCompeleteShowTop;
    return 1 - passProgress / allProgress;
  });
  const pointerEvents = computed(() => (opacity.value > 0.8 ? 'auto' : 'none'));
  const style = computed(() => ({
    opacity: opacity.value,
    pointerEvents: pointerEvents.value,
  }));
  const isCompeleteFixed = computed(() => opacity.value >= 0.98); // 真机上有一点点精度问题，降低下阈值
  return {
    /** header样式 */
    style,
    /** header当前高度 */
    headerHeight,
    /** tab当前高度 */
    tabHeight,
    /** 是否完全吸顶 */
    isCompeleteFixed,
  };
};
